import React, { useEffect, useRef, useState } from "react";
import {
  ImageIcon,
  PDFDoc,
  Redo,
  RippleLoaderSVG,
  Undo,
  User,
} from "../../../assets/svg/AllSvg";
import { headChat } from "../../../assets/image";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { uploadFile } from "../../../redux/uploadFile/slice";
import { io } from "socket.io-client";
import SendMsg from "../../../commons/SendMsg";
import ReceiveMsg from "../../../commons/ReceiveMsg";
import Action from "../../../commons/Action";
import DocumentsList from "../components/DocumentsList";
import { formats, modules } from "../../../commons/Editor";
import ReactQuill from "react-quill";
import { Form, Formik } from "formik";
import { Badge } from "../../../components/micro";
import { updateService } from "../../../redux/serviceRequest/slice";
import RippleLoader from "../../../commons/RippleLoader";

const ServiceRequestDetails = () => {
  const [isFileUpload, setIsFileUpload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [documentArray, setDocumentArray] = useState([]);
  const [chatDetails, setChatDetails] = useState([]);
  const [chatDocuments, setChatDocuments] = useState([]);
  const [chatData, setChatData] = useState({});
  const [chatText, setChatText] = useState("");
  const getAccessToken = sessionStorage.getItem("accessToken");
  const User_Id = sessionStorage.getItem("user_Id");
  const quillRef = useRef(null);
  const chatEndRef = useRef(null);
  const socketRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const serviceRequestId = location?.state?.id;
  const serviceRequest = location?.state;
  const socketURL = process.env.REACT_APP_SOCKET_URL;

  console.log(location?.state);

  // Scroll to the bottom whenever messages change
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatDetails]);

  // Start Socket
  useEffect(() => {
    socketRef.current = io(socketURL, {
      auth: {
        token: getAccessToken,
      },
    });

    socketRef.current.emit("getService", {
      serviceId: serviceRequestId,
    });

    socketRef.current.on("chatList", (data) => {
      setChatData(data?.data);
      setChatDetails(data?.data?.chats);
      setDocumentArray(data?.data?.documents);
    });

    socketRef.current.on("error", (err) => {
      console.log("err", err);
    });

    return () => {
      socketRef.current.disconnect();
    };
  }, [serviceRequestId, getAccessToken, socketURL]);

  // Get sender details
  useEffect(() => {
    const handleListingGroup = (data) => {
      setChatDetails((prev) => [...prev, { ...data?.data }]);
      setDocumentArray((prev) => [...prev, ...data?.data?.attachments]);
    };

    socketRef.current.on("listing-group", handleListingGroup);

    return () => {
      socketRef.current?.off &&
        socketRef.current.off("listing-group", handleListingGroup);
    };
  }, []);

  // Get New Message
  const getNewMessage = (setFieldValue) => {
    socketRef.current.on("newMessage", (data) => {
      setChatDetails([...chatDetails, { ...data?.data }]);
      setDocumentArray([...documentArray, ...data?.data?.attachments]);
      setChatDocuments([]);
    });
    setChatText("");
    setFieldValue("message", "");
  };

  // Send Message
  const sendMsg = (setFieldValue) => {
    const fillArray = chatDocuments?.map((e) => e.id);
    socketRef.current.emit("sendMessage", {
      content: chatText,
      service_request_id: serviceRequestId,
      user_id: User_Id,
      type:
        fillArray.length && chatText.length
          ? "text"
          : fillArray.length
          ? "media"
          : "text",
      attachments: fillArray,
    });
    getNewMessage(setFieldValue);
  };

  // Get File URL Upload Editor
  const handleUpload = (e) => {
    const file = e.target.files[0];
    const type = file?.type;
    const formData = new FormData();
    formData.append("type", "service_request");
    formData.append("file", file);
    formData.append(
      "document_type",
      type === "application/pdf" ? "doc" : "img"
    );
    setIsFileUpload(true);
    dispatch(uploadFile(formData)).then((res) => {
      setIsFileUpload(false);
      if (res.type === "uploadFile/fulfilled") {
        setChatDocuments((prevArray) => [...prevArray, res.payload.data]);
        quillRef.current?.getEditor();
      }
    });
  };

  // Add Undo and Redo buttons to the toolbar
  const CustomToolbar = () => (
    <div
      id="toolbar"
      className="flex justify-between md:items-center absolute md:inset-x-0 right-0 w-full pl-3 pr-3 md:left-20 md:pr-5 max-w-[calc(100%-75px)] h-10"
    >
      <div className="flex items-center space-x-2">
        <div className="relative mt-1">
          <ImageIcon width="15" height="15" className="ml-2" />
          <input
            type="file"
            accept=".jpeg,.jpg,.png,.pdf"
            className="absolute top-0 left-0 w-full h-full opacity-0"
            onChange={handleUpload}
          />
        </div>
      </div>
      <div className="flex items-center gap-3">
        <button
          className="ql-undo"
          type="button"
          onClick={() => quillRef.current.getEditor().history.undo()}
        >
          <Undo />
        </button>
        <button
          className="ql-redo"
          type="button"
          onClick={() => quillRef.current.getEditor().history.redo()}
        >
          <Redo />
        </button>
      </div>
    </div>
  );

  // Cancelled
  const handleCancelled = () => {
    setIsLoading(true);
    dispatch(
      updateService({ id: serviceRequestId, data: { status: "cancelled" } })
    ).then((res) => {
      setIsLoading(false);
      if (res.type === "updateService/fulfilled") {
        navigate("/on-going");
      }
    });
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center space-x-5 border-b-2 border-secondary_grey pb-7">
        <img src={headChat} alt="img" />
        <p className="text-2xl md:text-4xl font-ebGaramond">
          Your On-Going Service Requests
        </p>
      </div>
      {isLoading ? (
        <RippleLoader />
      ) : (
        <div className="border w-full !rounded-2xl space-y-4 !py-5 !px-4 md:!px-6">
          {/* Company And Service Request Details */}
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-5 mb-2">
            <div className="flex items-center gap-3 md:gap-5">
              <p className="font-ebGaramond sm:text-2xl text-xl">
                {chatData?.service?.service_name ||
                  serviceRequest?.service?.service_name ||
                  "-"}
              </p>
              {chatData?.status || serviceRequest?.status ? (
                <Badge
                  value={chatData?.status || serviceRequest?.status || "-"}
                  className={`${
                    chatData?.status ||
                    serviceRequest?.status === "billing_needed"
                      ? "border-orange-600 bg-orange-600 text-white"
                      : chatData?.status || serviceRequest?.status === "expired"
                      ? "border-orange-600 text-orange-600"
                      : chatData?.status || serviceRequest?.status === "pending"
                      ? "border-theme text-light_green"
                      : chatData?.status ||
                        serviceRequest?.status === "completed"
                      ? "text-light_green border-light_green"
                      : chatData?.status ||
                        serviceRequest?.status === "cancelled"
                      ? "border-red-600 text-red-600"
                      : "border-theme text-theme"
                  } text-xs !px-2 capitalize !py-0.5`}
                />
              ) : (
                "-"
              )}
            </div>
            <Action
              isEnd
              optionList={
                <>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-secondary_light_shades transition duration-300 cursor-pointer"
                    onClick={() => handleCancelled()}
                  >
                    Cancelled
                  </li>
                </>
              }
            />
          </div>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-5">
            <div className="space-y-1">
              <p className="md:text-base text-sm">
                Service Request ID:{" "}
                {chatData?.service_request_id ||
                  serviceRequest?.service_request_id ||
                  "-"}
              </p>
              <p className="md:text-base text-sm">
                To Be Completed By:{" "}
                {chatData?.to_be_completed_by ||
                  serviceRequest?.to_be_completed_by ||
                  "-"}
              </p>
            </div>
            <div className="space-y-1">
              <p className="md:text-base text-sm">
                Company Name:{" "}
                {chatData?.company?.name ||
                  serviceRequest?.company?.name ||
                  "-"}
              </p>
              <p className="md:text-sm text-xs text-light_grey">
                Customer Name:{" "}
                {chatData?.user?.full_name ||
                  serviceRequest?.user?.full_name ||
                  "-"}
              </p>
            </div>
          </div>
          {/* Chat Start */}
          <div className="py-4 px-4 grid grid-cols-1 md:grid-cols-5 gap-5 bg-white border rounded-xl space-y-1">
            <div className="space-y-1 md:col-span-4">
              <div className="max-h-[50vh] md:h-[calc(100vh-353px)] overflow-auto py-3 space-y-2">
                {chatDetails?.length ? (
                  <>
                    {chatDetails?.map((element) => {
                      return (
                        <>
                          {element?.user_id === Number(User_Id) ? (
                            <SendMsg element={element} />
                          ) : (
                            <ReceiveMsg element={element} />
                          )}
                        </>
                      );
                    })}
                  </>
                ) : null}
                <div ref={chatEndRef} />
              </div>

              {/* Chat Editor */}
              <Formik
                enableReinitialize={true}
                initialValues={{
                  message: "",
                }}
                // onSubmit={(values) => {
                //   console.log(values);
                // }}
              >
                {({ values, handleSubmit, setFieldValue }) => (
                  <Form className="w-full space-y-3" onSubmit={handleSubmit}>
                    <div className=" space-y-3">
                      {/* Message Editor */}
                      <div className="relative">
                        <CustomToolbar />
                        <ReactQuill
                          id="message"
                          name="message"
                          onChange={(e) => {
                            setFieldValue("message", e);
                            setChatText(e);
                          }}
                          onKeyPress={(e) =>
                            e.key === "Enter" && sendMsg(setFieldValue)
                          }
                          className="responsive_base_text chat-quill-container"
                          theme="snow"
                          value={values.message}
                          modules={modules}
                          formats={formats}
                          bounds={"#root"}
                          ref={quillRef}
                          placeholder={"Message"}
                        />
                        {/* <button
                          type="button"
                          className="absolute top-14 right-2 p-2"
                          onClick={() => sendMsg(setFieldValue)}
                        >
                          <Send />
                        </button> */}
                      </div>
                      {/* uploaded Fill */}
                      {isFileUpload ? (
                        <RippleLoaderSVG />
                      ) : (
                        <>
                          {chatDocuments?.length ? (
                            <div className="col-span-2 flex items-start border border-secondary_grey flex-wrap rounded px-4 py-3 gap-3 relative">
                              <label className="text-light_grey bg-white text-base px-2 absolute pointer-events-none scale-75 -translate-y-6 left-1">
                                Media
                              </label>
                              {chatDocuments?.map((element) => {
                                return (
                                  <>
                                    {element?.document_type === "doc" ? (
                                      <div
                                        className={
                                          "py-4 px-4 rounded-md bg-light_secondary flex justify-between items-center max-w-60 w-full relative"
                                        }
                                      >
                                        <div className="flex items-center w-full">
                                          <PDFDoc className="mr-3" />
                                          <p className="text-black font-normal max-w-full text-sm truncate">
                                            {element?.name}
                                          </p>
                                        </div>
                                        <button type="button">
                                          <Action
                                            optionList={
                                              <>
                                                <a
                                                  href={element?.url}
                                                  target="_blank"
                                                  rel="noreferrer"
                                                  className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-secondary_light_shades transition duration-300 cursor-pointer"
                                                >
                                                  View
                                                </a>
                                                <a
                                                  href={element?.url}
                                                  rel="noreferrer"
                                                  target="_blank"
                                                  className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-secondary_light_shades transition duration-300 cursor-pointer"
                                                >
                                                  Download
                                                </a>
                                              </>
                                            }
                                          />
                                        </button>
                                      </div>
                                    ) : (
                                      <div className="relative max-w-24 h-24 w-full rounded-md border-2">
                                        <button
                                          type="button"
                                          className="absolute bg-white rounded-md top-1 right-1"
                                        >
                                          <Action
                                            className="!px-2"
                                            optionList={
                                              <>
                                                <a
                                                  href={element?.url}
                                                  target="_blank"
                                                  rel="noreferrer"
                                                  className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-secondary_light_shades transition duration-300 cursor-pointer"
                                                >
                                                  View
                                                </a>
                                                <a
                                                  href={element?.url}
                                                  target="_blank"
                                                  rel="noreferrer"
                                                  className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-secondary_light_shades transition duration-300 cursor-pointer"
                                                >
                                                  Download
                                                </a>
                                              </>
                                            }
                                          />
                                        </button>
                                        <img
                                          src={element?.url}
                                          alt="img"
                                          className="w-full h-full rounded-md object-cover"
                                        />
                                      </div>
                                    )}
                                  </>
                                );
                              })}
                            </div>
                          ) : null}
                        </>
                      )}
                      {/* Message Editor */}
                      <div className="flex flex-col sm:flex-row sm:justify-between items-start sm:items-center gap-3">
                        <div className="flex items-center space-x-2 w-full">
                          <div className="max-w-8 w-full h-8 flex justify-center items-center bg-grey rounded-full">
                            {chatData?.handled_by?.profile_path ? (
                              <img
                                src={chatData?.handled_by?.profile_path}
                                alt="profile"
                                className="w-full h-full object-cover"
                              />
                            ) : (
                              <User pathClass="fill-white" fillOpacity={1} />
                            )}
                          </div>
                          <p className="text-theme border-b border-theme">
                            {chatData?.handled_by?.full_name}
                          </p>
                        </div>
                        <button
                          type="submit"
                          className="btn-theme uppercase whitespace-nowrap w-full sm:w-auto"
                          onClick={() => sendMsg(setFieldValue)}
                        >
                          Submit Reply
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
            {/* Documents List */}
            <div className="md:col-span-1">
              <DocumentsList documentArray={documentArray} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceRequestDetails;
